export default __webpack_public_path__ + "static/media/VisitedPlaces.427947e6.png";